import { countries } from "./territories.js"

/**
 * Two-letter country code, or "" when the value is missing or not a code.
 */
function normalizeCountryCode(value) {
  const code = String(value || "").trim().toUpperCase()
  return /^[A-Z]{2}$/.test(code) ? code : ""
}

function headerValue(headers, name) {
  if (!headers) return ""
  if (typeof headers.get === "function") {
    return headers.get(name) || headers.get(name.toLowerCase()) || ""
  }
  const key = Object.keys(headers).find((item) => item.toLowerCase() === name.toLowerCase())
  return key ? headers[key] : ""
}

/**
 * Netlify sends the visitor IP country as `x-country` (a two-letter code)
 * and as `x-nf-geo` (base64 JSON `{ country: { code, name }, ... }`).
 * Returns "" when the header is missing or unreadable.
 */
export function countryCodeFromNetlifyGeoHeader(value) {
  const raw = Array.isArray(value) ? value[0] : value
  if (!raw || typeof raw !== "string") return ""

  try {
    const json = JSON.parse(Buffer.from(raw.trim(), "base64").toString("utf8"))
    return normalizeCountryCode(json?.country?.code)
  } catch {
    return ""
  }
}

/**
 * Country code from the request Netlify geolocated.
 * `x-country` wins. `x-nf-geo` is the fallback. "" means no preselection.
 */
export function visitorCountryFromHeaders(headers) {
  const fromCountry = normalizeCountryCode(headerValue(headers, "x-country"))
  if (fromCountry) return fromCountry
  return countryCodeFromNetlifyGeoHeader(headerValue(headers, "x-nf-geo"))
}

/**
 * Country to preselect in the rep finder.
 * A missing code, or one that is not in the country list, stays empty.
 * A listed country is returned even when no rep covers it.
 */
export function preselectCountryCode(code) {
  const country = normalizeCountryCode(code)
  if (!country) return ""
  return countries().some((item) => item.code === country) ? country : ""
}

/** True when a rep's territory is this country or one of its states or provinces. */
export function countryHasRep(directory, code) {
  const country = normalizeCountryCode(code)
  if (!country) return false
  const prefix = `${country}-`
  return (directory?.reps || []).some((rep) =>
    (rep.territories || []).some(
      (territory) => territory === country || territory.startsWith(prefix)
    )
  )
}
